import React, { useState, useEffect } from 'react'
import { Formik, Form, Field } from 'formik'
import { connect } from 'react-redux'
import { Form as BootstrapForm, Button, Image, Row, Col, Alert } from 'react-bootstrap'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { authUser, acceptInvitation } from '../store/auth/actions'
import registerStep1 from '../../assets/images/register/register-step1.png'

function Login({
  dispatchAuthUser,
  dispatchAcceptInvitation,
  loading,
  error,
  cartData
}) {
  const query = new URLSearchParams(useLocation().search)
  const [urlKey, setUrlKey] = useState(query.get('k') ?? null)
  const [notAuth, setNotAuth] = useState(false)
  const [notAuthMsg, setNotAuthMsg] = useState('Please login before this action!')
  const history = useHistory()
  const isDemoMode = process.env.MIX_DEMO_MODE === 'true'

  useEffect(() => {
    if (history.location?.state?.not_auth) {
      setNotAuth(true)

      if (history.location?.state?.not_auth_msg) {
        setNotAuthMsg(history.location?.state?.not_auth_msg)
      }
    }
  }, [])

  const onLogin = async (values) => {
    await dispatchAuthUser(values, history, () => {
      if (urlKey) {
        dispatchAcceptInvitation(urlKey, null, history)
        history.push('/')
      }
      else if (cartData?.length > 0) {
        history.push('/cart')
      }
      else {
        history.push('/')
      }
    })
  }
  

  return (
    <div className="page page-register">
      <div className="container">
        <div className="page-backlink">
          {/*<Link to="/">Back to Lowman Product Library</Link>*/}
          <Link to="#" onClick={() => history.goBack()}>Go to Previous page</Link>
        </div>
        <div className="page-title">
          <h2>Log in to your account</h2>
        </div>
        {notAuth && <Alert variant="warning">{notAuthMsg}</Alert>}
        <Formik
          initialValues={{
            email: '',
            password: ''
          }}
          // validationSchema={loginSchema}
          onSubmit={(values) => {
            onLogin(values)
          }}
          enableReinitialize>
          {({ errors, touched, handleChange, isValid, dirty }) => (
            <Form id="form-login" className="form form-register">
              <BootstrapForm.Group controlId="login-email">
                <BootstrapForm.Label>Email</BootstrapForm.Label>
                <div className="form-control-wrapper">
                  <Field
                    id="login-email"
                    className="form-control"
                    type="email"
                    name="email"
                    onChange={(e) => handleChange(e)}
                  />
                  {error && error[0]?.reason?.graphQLErrors && error[0]?.reason?.graphQLErrors[0]?.validation['input.username'] ? (
                    <div className="error">{error[0]?.reason.graphQLErrors[0]?.validation['input.username'][0]}</div>
                  ) : null}
                </div>
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId="login-password">
                <BootstrapForm.Label>Password</BootstrapForm.Label>
                <div className="form-control-wrapper">
                  <Field
                    id="login-password"
                    className="form-control"
                    type="password"
                    name="password"
                    onChange={(e) => handleChange(e)}
                  />
                  {error && error[0]?.reason?.graphQLErrors && error[0]?.reason.graphQLErrors[0]?.validation['input.password'] ? (
                    <div className="error">{error[0]?.reason.graphQLErrors[0]?.validation['input.password'][0]}</div>
                  ) : null}
                </div>
              </BootstrapForm.Group>
              {error && (
                <Row>
                  {/*<Col>{error.map((item) => item.reason).join('\n')}</Col>*/}
                  <Col className="text-danger" style={{ fontSize: '14px', marginBottom: '20px' }}>
                    {error[0]?.reason.message}
                  </Col>
                </Row>
              )}
              <div className="form-buttons">
                <div className="buttons-wrapper">
                  <Button type="submit" color="default" disabled={!isValid || !dirty || loading}>
                    {loading ? 'Loading..' : 'Log in'}
                  </Button>
                  {!isDemoMode && (
                    <div>
                      Don&apost have an account yet?
                      <div>
                        <Link to="/register">Create an account now</Link>
                      </div>
                      <div>
                        <Link to="/forgot-password">Forgot password</Link>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <div className="page-image">
        <Image src={registerStep1} alt="cat and laptop on table" fluid />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { error, loading, acceptInvitation } = state.auth
  const { data: cartData } = state.cart

  return { error, loading, cartData, acceptInvitation }
}

const mapDispatchToProps = {
  dispatchAuthUser: authUser,
  dispatchAcceptInvitation: acceptInvitation
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
